import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EmptyState } from '@/shared/components/empty-state';
import { formatCurrency } from '@/shared/lib/format';

import type { DashboardRevenue } from '../types/dashboard.types';

/**
 * Completed orders' revenue and provider cost, one row per currency — never
 * summed across currencies. The margin is the backend's figures side by
 * side; the frontend does no financial arithmetic.
 */
export function RevenueCard({ revenue }: { revenue: DashboardRevenue[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Revenue from completed orders</CardTitle>
      </CardHeader>
      <CardContent>
        {revenue.length === 0 ? (
          <EmptyState title="No completed orders in this period" className="h-24" />
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-muted-foreground text-xs">
                <th className="py-1 text-start font-medium">Currency</th>
                <th className="py-1 text-end font-medium">Revenue</th>
                <th className="py-1 text-end font-medium">Provider cost</th>
              </tr>
            </thead>
            <tbody>
              {revenue.map((row) => (
                <tr key={row.currencyCode} className="border-t">
                  <td className="py-1.5">{row.currencyCode}</td>
                  <td className="py-1.5 text-end tabular-nums">
                    {formatCurrency(row.revenue, row.currencyCode)}
                  </td>
                  <td className="py-1.5 text-end tabular-nums">
                    {formatCurrency(row.cost, row.currencyCode)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CardContent>
    </Card>
  );
}
